import type { InventoryVehicle } from '@carvana/merch-contracts';
import InventoryConditionalTile from '~/contracts/srp/InventoryConditionalTile';

export default function injectInventoryConditionalTiles<
  V extends InventoryVehicle
>(
  vehicles: V[],
  conditionalTiles: InventoryConditionalTile[]
): Array<InventoryConditionalTile | V> {
  const tiles: Array<InventoryConditionalTile | V> = [...vehicles];

  conditionalTiles.forEach(tile => {
    if (tile.position === -1) {
      tiles.push(tile);
    } else {
      tiles.splice(tile.position, 0, tile);
    }
  });

  return tiles;
}
